import {
  pageClick,
  wasItHelpfulView,
  helpCenterModals,
} from '@wix/bi-logger-new-help-center/v2';
import { useRouter } from 'next/router';

import { BI } from '../../../constants';
import { useBI } from '../../../hooks/useBI';

export const useKeraAssistantBI = (
  itemId: string,
  selfServiceSessionId?: string
) => {
  const { sendBIEvent } = useBI();
  const { locale } = useRouter();

  const commonProps = {
    item_id: itemId,
    source_name: BI.SOURCE_NAMES.ARTICLE,
    kb_lang: locale,
    ...(selfServiceSessionId && {
      self_service_session_id: selfServiceSessionId,
    }),
  };

  const onKeraAssistantClick = async (clickedText: string) => {
    await sendBIEvent(
      pageClick({
        ...commonProps,
        clicked_item_type: BI.CLICKED_ITEM_TYPES.KERA_ASSISTANT_BANNER_CTA,
        clicked_text: clickedText,
      })
    );
  };

  const onKeraAssistantExposure = async () => {
    await sendBIEvent(
      wasItHelpfulView({
        ...commonProps,
        item_name: BI.ITEM_NAMES.KERA_ASSISTANT,
      })
    );
  };

  const onKeraAssistantClose = async () => {
    await sendBIEvent(
      pageClick({
        ...commonProps,
        clicked_item_type: BI.CLICKED_ITEM_TYPES.KERA_ASSISTANT_BANNER_CLOSE,
        clicked_text: BI.CLICKED_ITEM_TYPES.CLOSE,
      })
    );
  };

  const onConfirmationModalLoad = async () => {
    await sendBIEvent(
      helpCenterModals({
        ...commonProps,
        action_type: BI.ACTION_TYPE.MODAL_LOAD,
        modal_name: BI.MODAL_NAME.KERA_ASSISTANT_SHARE_SCREEN_CONFIRMATION,
      })
    );
  };

  const onConfirmationModalApprove = async () => {
    await sendBIEvent(
      helpCenterModals({
        ...commonProps,
        action_type: BI.ACTION_TYPE.MODAL_CLICK,
        modal_name: BI.MODAL_NAME.KERA_ASSISTANT_SHARE_SCREEN_CONFIRMATION,
        clicked_button_name: BI.CLICKED_ITEM_TYPES.APPROVE,
      })
    );
  };

  const onConfirmationModalClose = async () => {
    await sendBIEvent(
      helpCenterModals({
        ...commonProps,
        action_type: BI.ACTION_TYPE.MODAL_CLICK,
        modal_name: BI.MODAL_NAME.KERA_ASSISTANT_SHARE_SCREEN_CONFIRMATION,
        clicked_button_name: BI.CLICKED_ITEM_TYPES.CLOSE,
      })
    );
  };

  return {
    onKeraAssistantClick,
    onKeraAssistantExposure,
    onKeraAssistantClose,
    onConfirmationModalLoad,
    onConfirmationModalApprove,
    onConfirmationModalClose,
  };
};
